// extracted by mini-css-extract-plugin
module.exports = {"notFoundCard":"NotFoundCard_notFoundCard__17nZk","header":"NotFoundCard_header__2s64q","title":"NotFoundCard_title__2qTkz","boldText":"NotFoundCard_boldText__3fXGd"};